var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragDropIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.0996 24.0527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 24.0527,
    opacity: 0,
    width: 17.0996,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36914 0C8.08594 0 7.83203 0.126953 7.61719 0.341797L0.283203 7.39258C0.107422 7.56836 0 7.79297 0 8.10547C0 8.65234 0.419922 9.07227 0.976562 9.07227C1.20117 9.07227 1.45508 9.00391 1.68945 8.7793L8.36914 2.23633L15.0488 8.7793C15.2832 8.99414 15.5371 9.07227 15.7617 9.07227C16.3184 9.07227 16.7383 8.65234 16.7383 8.10547C16.7383 7.79297 16.6211 7.56836 16.4551 7.39258L9.12109 0.341797C8.90625 0.126953 8.65234 0 8.36914 0ZM8.36914 24.0332C8.65234 24.0332 8.90625 23.916 9.12109 23.7012L16.4551 16.6406C16.6211 16.4648 16.7383 16.2402 16.7383 15.9375C16.7383 15.3809 16.3184 14.9707 15.7617 14.9707C15.5371 14.9707 15.2832 15.0391 15.0488 15.2539L8.36914 21.7969L1.68945 15.2539C1.45508 15.0293 1.20117 14.9707 0.976562 14.9707C0.419922 14.9707 0 15.3809 0 15.9375C0 16.2402 0.107422 16.4648 0.283203 16.6406L7.61719 23.7012C7.83203 23.916 8.08594 24.0332 8.36914 24.0332Z",
    fill: "black",
    fillOpacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropIcon);
export default __webpack_public_path__ + "static/media/drag_drop_icon.39c911271774e27a80dc2254be545fa4.svg";
export { ForwardRef as ReactComponent };